const SECTIONS_TYPES = {
  HOME: "home",
  GALLERY: "gallery",
  DONATE: "donate",
  RECRUITMENT: "recruitment",
  CUSTOM_SECTION: "custom",
  MARKETING_CUSTOM_SECTION: "marketing",
  NEWS: "news"
}

export default SECTIONS_TYPES
